module.exports = __webpack_public_path__ + "img/bachelor-hes-systemes-industriel.4bfb6479.jpg";